import DOMPurify from "dompurify";

// Links that open in a new tab keep doing so, but the new tab cannot reach
// back into this window. In templates, only stylesheet <link>s are kept.
DOMPurify.addHook("uponSanitizeElement", (node, data) => {
    if (data.tagName === "link" && (node.getAttribute("rel") || "").trim().toLowerCase() !== "stylesheet" && node.parentNode) {
        node.parentNode.removeChild(node);
    }
});
DOMPurify.addHook("afterSanitizeAttributes", node => {
    if (node.tagName === "A" && node.getAttribute("target")) {
        node.setAttribute("rel", "noopener noreferrer");
    }
});

// Strips scripts, event handlers and javascript: URLs from HTML before it is
// put into the page. Use this for every dangerouslySetInnerHTML / innerHTML
// whose value did not come from a literal in this codebase.
export function sanitizeHtml(html, options = {}) {
    if (html === null || html === undefined || html === "") {
        return "";
    }
    return DOMPurify.sanitize(String(html), { ADD_ATTR: ["target"], ...options });
}

// For full document templates (e-sign agreements). They carry their own <style>
// blocks and stylesheet links, declare a charset (Hindi agreements need it once
// the HTML is sent for signing), and rely on element ids so fields can be filled.
export function sanitizeTemplateHtml(html) {
    return sanitizeHtml(html, {
        FORCE_BODY: true,
        SANITIZE_DOM: false,
        ADD_TAGS: ["link", "meta"],
        ADD_ATTR: ["target", "rel", "media", "charset"]
    });
}
